import { Navigate } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import { useRef, type JSX, useEffect, Suspense as ReactSuspense } from 'react';

import { ChildrenProps } from 'types';

interface ProtectedRouteProps {
  allowed: boolean;
  redirect: string;
  onWillRedirect?: () => void;
}

export const ProtectedRoute = ({
  allowed,
  redirect,
  children,
  onWillRedirect,
}: ChildrenProps<ProtectedRouteProps>): JSX.Element => {
  const redirectHandledRef = useRef(false);

  useEffect(() => {
    if (allowed) {
      redirectHandledRef.current = false;
      return;
    }

    if (redirectHandledRef.current) {
      return;
    }

    redirectHandledRef.current = true;
    onWillRedirect?.();
  }, [allowed, onWillRedirect]);

  if (!allowed) {
    return <Navigate to={redirect} />;
  }

  return <>{children}</>;
};

export const Suspense = ({ children }: ChildrenProps): JSX.Element => (
  <ReactSuspense fallback={<CircularProgress />}>{children}</ReactSuspense>
);
